__turbopack_context__.v({
  "abnormal": "Status-module-scss-module__Rsc82W__abnormal",
  "collecting": "Status-module-scss-module__Rsc82W__collecting",
  "icon": "Status-module-scss-module__Rsc82W__icon",
  "new": "Status-module-scss-module__Rsc82W__new",
  "normal": "Status-module-scss-module__Rsc82W__normal",
  "outer": "Status-module-scss-module__Rsc82W__outer",
  "primary": "Status-module-scss-module__Rsc82W__primary",
  "text": "Status-module-scss-module__Rsc82W__text",
});
